import { ActionTypes } from '../constants';
import { RootActionTypes } from '../../../stores/types';

export default function showAllTariffCodes(): RootActionTypes {
  return { type: ActionTypes.SHOW_ALL_TARIFF_CODES };
}
